import Script from 'next/script'

type ChatBubbleProps = {
  disabled?: boolean
}

const HELP_SCOUT_BEACON_ID = 'b0e8609e-0238-479b-99a1-1bcaceb5d598'

export function HelpScoutChatBubble({ disabled }: ChatBubbleProps) {
  return !!disabled ? null : (
    <>
      <Script id="chat-bubble-1" type="text/plain" data-category="necessary">
        {`
          !(function (e, t, n) {
            function a() {
              var e = t.getElementsByTagName("script")[0],
                n = t.createElement("script");
              (n.type = "text/javascript"),
                (n.async = !0),
                (n.src = "https://beacon-v2.helpscout.net"),
                e.parentNode.insertBefore(n, e);
            }
            if (
              ((e.Beacon = n =
                function (t, n, a) {
                  e.Beacon.readyQueue.push({ method: t, options: n, data: a });
                }),
              (n.readyQueue = []),
              "complete" === t.readyState)
            )
              return a();
            e.attachEvent
              ? e.attachEvent("onload", a)
              : e.addEventListener("load", a, !1);
          })(window, document, window.Beacon || function () {});
        `}
      </Script>
      <Script id="chat-bubble-2" type="text/plain" data-category="necessary">
        {`
          window.Beacon('init', '${HELP_SCOUT_BEACON_ID}')
        `}
      </Script>
      <Script id="chat-bubble-3" type="text/plain" data-category="necessary">
        {`
          window.Beacon('config', {
            display: {
              zIndex: 10
            },
          });
        `}
      </Script>
    </>
  )
}
